import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appClick]'  // Update the selector to match the HTML attribute
})
export class ClickDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  // Listen to click events on the element
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    // console.log('Element clicked:', event);  // Just log the click for now
  }

  // Listen for keyboard events (Enter or Space)
  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      // Simulate the click event when Enter or Space is pressed
      // alert('Key pressed: ' + event.key);  // Just log the key for now
      const htmlElement = this.el.nativeElement as HTMLElement;
      htmlElement.click();
    }
  }

  // Listen for the focus event on the element
  // @HostListener('focus', ['$event'])
  // onFocus(event: FocusEvent): void {
  //   // console.log('Element focused:', event);    
  //   const htmlElement = this.el.nativeElement as HTMLElement;
  //   // this.renderer.setStyle(htmlElement, 'outline', '2px solid blue');
  // }

  // Optionally handle the blur event (when the element loses focus)
  // @HostListener('blur', ['$event'])
  // onBlur(event: FocusEvent): void {
  //   // console.log('Element lost focus:', event);
  //   const htmlElement = this.el.nativeElement as HTMLElement;
  //   this.renderer.removeStyle(htmlElement, 'outline');  // Remove focus style
  // }

  // Listen for hover events and simulate focus
  // @HostListener('mouseenter', ['$event'])
  // onMouseEnter(event: MouseEvent): void {
  //   console.log('Element hovered:', event);
  //   const htmlElement = this.el.nativeElement as HTMLElement;
  //   htmlElement.focus();  // Programmatically focus the element when hovered
  //   this.renderer.setStyle(htmlElement, 'outline', '2px solid blue');
  // }

  // @HostListener('mouseleave', ['$event'])
  // onMouseLeave(event: MouseEvent): void {
  //   console.log('Mouse left the element:', event);
  //   const htmlElement = this.el.nativeElement as HTMLElement;
  //   // Optionally remove the focus style when mouse leaves the element
  //   this.renderer.removeStyle(htmlElement, 'outline');
  // }
}
